// extracted by mini-css-extract-plugin
module.exports = {"link":"salify-link_link__g3PVp"};